import React, { createContext, useState, useContext } from "react";
import CommonAlert from "../common/CommonAlert";

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);

  const showAlert = (type, message, description, timeout) => {
    const validTypes = ["success", "info", "warning", "error"];
    let alertType = type;
    let alertMessage = message;
    let alertDescription = description;
    let alertTimeout = timeout;

    // Handle reversed parameters e.g. showAlert("message", "type") or showAlert("message")
    if (typeof type === "string" && !validTypes.includes(type)) {
      if (typeof message === "string" && validTypes.includes(message)) {
        alertType = message;
        alertMessage = type;
      } else {
        alertType = "info";
        alertMessage = type;
        if (typeof message === "string") {
          alertDescription = message;
        }
      }
    }

    setAlert({ type: alertType, message: alertMessage, description: alertDescription });
    setTimeout(() => setAlert(null), alertTimeout || 5000); // Auto-dismiss after 5 seconds
  };

  return (
    <AlertContext.Provider value={{ alert, showAlert }}>
      {alert && (
        <CommonAlert
          type={alert.type}
          message={alert.message}
          description={alert.description}
          onClose={() => setAlert(null)}
        />
      )}
      {children}
    </AlertContext.Provider>
  );
};
